/**
 * 8select add to Cart
 * nur auf der Shop The Look Seite
 */

import * as loginReauthentication from "@JS/shop/10-login-component/loginReauthentication";
import * as utils from "@sharedJS/utils";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

function addToCart(productID) {
	if (loginReauthentication.doPageReloadForCoopUser() === false && document.querySelector("[data-8select-widget-id]")) {
		const url = utils.getUrl(`/rest/cart/product/${productID}`);
		const popup = $("#js-cart-popup");
		const popupContent = popup.find(".popupContent").first();

		$.ajax({
			url,
			global: false,
			type: "PUT",
			dataType: "json",
			headers: {
				CSRFToken: ocm.config.CSRFToken,
			},
			cache: false,
		})
			.done((data) => {
				popupContent.html(buildHTML(data.headline, data.message));
				ocm.popUpOverlay.openPopup(popup, { blur: true });
				OcmMessenger.publish(messengerPublicationTypes.UPDATED_MINI_CART);
				OcmMessenger.publish(messengerPublicationTypes.UPDATED_CART);
			})
			.fail((jqXHR, textStatus, errorThrown) => {
				const errorHeadline = jqXHR.responseJSON.headline || "Ein Fehler ist aufgetreten";
				popupContent.html(buildErrorHTML(errorHeadline));
				ocm.popUpOverlay.openPopup(popup, { blur: true });
				console.error(errorThrown);
			});
	}
}

function buildHTML(headline, message) {
	const cartUrl = utils.getUrl(`/cart/`);
	let html = '<div class="c-cart-popup">';
	html += `<div class="c-cart-popup__headline"><h3>${headline}</h3></div>`;
	html += '<div class="c-cart-popup__content">';
	html += `<div class="c-cart-popup__message-success u-inline-block"><span class="c-cart-popup__icon-success c-icon c-icon--hook-2"></span>${message}</div>`;
	html += `<a href="${cartUrl}" class="c-cart-popup__action-button o-btn c-btn--normal">WARENKORB ANSEHEN</a>`;
	html += "</div>";
	html += "</div>";
	return html;
}

function buildErrorHTML(headline) {
	let html = '<div class="[ c-cart-popup ]">';
	html += `<div class="c-cart-popup__headline"><h3></h3></div>`;
	html += '<div class="c-cart-popup__content">';
	html += `<div class="cart_popup_error_msg   u-error-text  u-inline-block">${headline}</div>`;
	html += "</div>";
	html += "</div>";
	return html;
}

export { addToCart };
